import React, { useRef } from 'react';
import { Box } from '@mui/material';
import useOutsideClickHandler from '../../../../lib/useOutsideClickHandler';

/**
 * @description A wrapper to handle toggling the search UI based on clicks outside of container
 */
const ActorsListWrapper = ({
  children,
  onBlur,
}: {
  children: React.ReactNode;
  onBlur: () => void;
}) => {
  const wrapperRef = useRef<HTMLDivElement>();
  useOutsideClickHandler(wrapperRef, onBlur);
  return <Box {...{ ref: wrapperRef }}>{children}</Box>;
};

export default ActorsListWrapper;
